import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import store from '@/store'
import packageJson from '../../package.json'

let user
let type
if (store.state.member.token) {
	const member = store.state.member.info
	user = {
		id: member.member_id,
		name: member.member_truename || member.name,
		email: member.member_emailbind !== 0 ? member.member_email : undefined
	}
	type = 'member'
} else if (store.state.distributor.token) {
	const distributor = store.state.distributor.info
	user = {
		id: distributor.user_id || undefined,
		name: distributor.real_name || distributor.user_name,
		email: distributor.email || undefined
	}
	type = 'distributor'
}

if (process.env.NODE_ENV !== 'development') {
	if (!user) {
		console.warn('[Bugsnag] user is undefined')
	} else {
		Bugsnag.start({
			appVersion: packageJson.version,
			apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
			plugins: [new BugsnagPluginVue(Vue)],
			releaseStage: process.env.NODE_ENV,
			user: user,
			onError: function (event) {
				if (type) {
					event.addMetadata('client', {
						'type': type
					})
				}
			}
		})
		const bugsnagVue = Bugsnag.getPlugin('vue')
		bugsnagVue.installVueErrorHandler(Vue)
		console.info('[Bugsnag] Bugsnag is ready')
	}
} else {
	console.warn('[Bugsnag] only production or staging environment.')
}
